// Precision of a Fire detection's stored `event_date` (WB-1328). Sources differ
// in how precisely they date an event: license boards give an exact day, some
// registries only a month or year, and present-state reads (e.g. "currently
// suspended") carry no transition date — only the date the status was confirmed.
//   day    → exact date            → display MM/DD/YYYY
//   month  → YYYY-MM-01 anchor      → display MM/YY
//   year   → YYYY-01-01 anchor      → display YYYY
//   as_of  → confirmation/check date → display "as of MM/DD/YYYY"
// Nullable everywhere: a null/absent precision is legacy and downstream treats
// it as `day` (full MM/DD/YYYY).
export enum DetectionEventDatePrecision {
  DAY = "day",
  MONTH = "month",
  YEAR = "year",
  AS_OF = "as_of",
}
